import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { spacing } }) => css`
    display: grid;
    grid-auto-columns: max-content;
    grid-auto-flow: column;
    grid-auto-rows: ${spacing.km8};
    grid-gap: ${spacing.km4};
    margin-bottom: ${spacing.km3};
  `}
`;
